<template>
    <div layout="row sm-column top-left" style="margin-top: 2rem; margin-bottom: 8rem; min-height:70vh">
        <div self="size-4of5" style="margin-right: 1rem;margin-bottom: 1rem">
            <img2 class="content-image" src="/static/img/me.jpg"/>
        </div>
        <div>
            Björn is a freelance designer and developer based in Heidelberg.<br>

            He is combining design- and technical skills and is always enthusiastic in learning new stuff.<br>

            He focuses on crafting interactive and digital cross-platform experiences and uses the best tools to get the job done.


            <p><strong>Buzzwords</strong><br>
                Creative Conception, Interface Design, Scribbles, Storyboards, Gamification, Augmented Reality, Game Development, Location-Based, Multiplayer Apps and Games, Backend Development </p>
            <p>If you would like to know any further details, or if you are interested in working with Björn, please don’t hesitate to get in touch.
            </p>
            <p><a href="mailto:me@bjoernacker.de?body=Hi Björn!">me(ät)bjoernacker.de</a><br>
                <strong>+49 (0) 179 133 1819</strong></p>
            <p>
                <a href="https://github.com/bma73/" target="_blank"><img class="icon" src="@/assets/github.svg"/></a>
                <a href="https://www.xing.com/profile/Bjoern_Acker" target="_blank"><img class="icon" src="@/assets/xing.svg"/></a>
                <a href="https://https://www.linkedin.com/in/bjoern-acker/" target="_blank"><img class="icon" src="@/assets/linkedin.svg"/></a>
            </p>
        </div>
    </div>
</template>

<script>
    import Panel from "@/components/Panel";

    export default {
        components: {Panel},
        name: 'skills',
        mounted() {
            this.$preloader.hide();
        }

    }
</script>

<style lang="scss" scoped>
    .icon {
        width: 2.5rem;
        margin-right: 1rem;

    }
    a::after {
        content: "";
    }
</style>
